import { render, staticRenderFns } from "./create-retur-form.vue?vue&type=template&id=55501c7f&"
import script from "./create-retur-form.vue?vue&type=script&lang=js&"
export * from "./create-retur-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports